import { ResponsiveLine } from '@nivo/line';
import React from 'react';

import { truncateValue } from '~/utils/helpers';
import { TooltipContent } from '~/views/audiences/AudiencePage/Tabs/OverviewPage/components/PointTooltip/PointTooltip.styles';

import { ChartTitle, ChartWrapper } from './AIInsightsUI.styles';
import { LineChartBlock } from './blockTypes';
import { formatCompactNumber, getCategoryTickRotation, getCategoryTickValues } from './chartAxis';
import {
  CATEGORY_LABEL_MAX_CHARS,
  LEGEND_OFFSET_BOTTOM_NORMAL,
  LEGEND_OFFSET_BOTTOM_ROTATED,
  MARGIN_BOTTOM_NORMAL,
  MARGIN_BOTTOM_ROTATED,
  MAX_LINE_CHART_TICKS,
} from './chartConfig';

interface Props {
  block: LineChartBlock;
}

const SimpleLineChart = ({ block }: Props) => {
  const data = [{ id: block.title, data: block.data.map((d) => ({ x: d.x, y: d.y })) }];
  const xLabels = block.data.map((d) => d.x);
  const tickRotation = getCategoryTickRotation(xLabels);

  return (
    <div>
      <ChartTitle>{block.title}</ChartTitle>
      <ChartWrapper>
        <ResponsiveLine
          data={data}
          margin={{ top: 20, right: 20, bottom: tickRotation ? MARGIN_BOTTOM_ROTATED : MARGIN_BOTTOM_NORMAL, left: 60 }}
          axisBottom={{
            legend: block.xLabel,
            legendPosition: 'middle',
            legendOffset: tickRotation ? LEGEND_OFFSET_BOTTOM_ROTATED : LEGEND_OFFSET_BOTTOM_NORMAL,
            tickValues: getCategoryTickValues(xLabels, MAX_LINE_CHART_TICKS),
            tickRotation,
            format: (v) => (v != null ? truncateValue(String(v), CATEGORY_LABEL_MAX_CHARS) : ''), // see docs/ai-insights-chart-rendering.md §3
          }}
          axisLeft={{
            legend: block.yLabel,
            legendPosition: 'middle',
            legendOffset: -50,
            format: (v) => formatCompactNumber(Number(v)),
          }}
          enablePoints={true}
          pointSize={8}
          useMesh={true}
          animate={true}
          tooltip={({ point }) => (
            <TooltipContent>{`${point.data.xFormatted as string}: ${point.data.yFormatted as string}`}</TooltipContent>
          )}
          colors={['#f97316']}
          pointColor="#ffffff"
          pointBorderWidth={2}
          pointBorderColor={{ from: 'serieColor' }}
          theme={{
            axis: {
              ticks: { text: { fontSize: 11, fill: '#6b7280' } },
              legend: { text: { fontSize: 11, fill: '#6b7280' } },
            },
            grid: { line: { stroke: '#f3f4f6' } },
          }}
        />
      </ChartWrapper>
    </div>
  );
};

export default SimpleLineChart;
